<template>    
    <download-link :href="url" target="_system" > 
        <slot></slot>
    </download-link>    
</template>
<script>
import api from '/plugins/api';
import qs from 'query-string';

export default {
    data() {
        return {
            token: null
        }
    },
	computed: {
		refresh_token() {
			return this.$store.state.refresh_token;
        },
        condominio() {
            return this.$store.getters.condominio;
        },
        codigo_condominio() {
            if (!this.condominio) {
                return null;
            }
            return this.condominio.codigo;
        },
        empresa() {
            return this.$store.state.empresa;
        },
        url() {
            if (!this.token) {
                return '';
            }

            let query = qs.stringify({
                ...this.token,
                expires_at: this.token.expiresAt,
                codigo_condominio: this.codigo_condominio
            });
            origin = `https://${this.empresa.domain}`;
            return `${origin}/assembleias?${query}`;
        }
	},
	methods: {
		async loadRefreshToken() {
            try {
                /*
                this.token = {
                    jwt: this.$store.state.jwt,
                    refresh_token: this.$store.state.refresh_token,
                    expires_at: this.$store.state.expiresAt
                };
                return;
                */
                this.token = null;
                let { data: token } = await api.post('assembleias', {
                    refresh_token: this.refresh_token
                });
                this.token = token;                
            } catch (err) {
                console.error(err);
            }
		}
	},
	watch: {
		jwt: {
			immediate: true,
			handler() {
				this.loadRefreshToken()
			}
		}
	}
}
</script>
